// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { any, number } from "@altostra/type-validations/lib/primitives";

export const isAppsBusinessAccountsDatatableResult = objectOf({
  hits: number,
  results: arrayOf(objectOf({ any })),
});
